import { FunctionComponent, useState, useEffect, useRef } from "react";
import styles from "./Collapsible.module.scss";
import { CollapsibleList, SimpleListItem } from "@rmwc/list";
import "@rmwc/list/styles";

type ownProps = {
  text: string;
  graphic?: string;
  children: JSX.Element | string | number;
  // type: gray or blue
  type?: string;
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
};

const Collapsible: FunctionComponent<ownProps> = (props: ownProps) => {
  const { text, graphic, children, type, open, onOpen, onClose } = props;
  const [isOpen, setOpen] = useState(!!open);
  const [width, setWidth] = useState(200);
  const coverRef = useRef(null);

  useEffect(() => {
    setOpen(!!open);
  }, [open]);

  useEffect(() => {
    getCollapsibleWidth();
    window.addEventListener("resize", getCollapsibleWidth);
    return () => window.removeEventListener("resize", getCollapsibleWidth);
  }, []);

  const getCollapsibleWidth = () => {
    const dom = coverRef.current as unknown as HTMLElement;
    setWidth(dom.clientWidth as number);
  };

  return (
    <div
      className={
        styles.CollapsibleComponent +
        " " +
        (type ? styles[type as string] : styles.blue)
      }
      ref={coverRef}
    >
      <div
        className="cover"
        style={{
          position: "absolute",
          height: "3rem",
          width: width,
          zIndex: 1,
          cursor: "pointer",
        }}
        onClick={() => setOpen(!isOpen)}
      ></div>
      <CollapsibleList
        open={isOpen}
        handle={
          <SimpleListItem
            text={text}
            graphic={graphic}
            metaIcon="chevron_right"
          />
        }
        onOpen={() => onOpen && onOpen()}
        onClose={() => onClose && onClose()}
      >
        {children || ""}
      </CollapsibleList>
    </div>
  );
};

export { Collapsible, Collapsible as default };
